import React from "react";
import { connect } from "react-redux";
import { toggleMenu } from "../../../actions";
import NavItems from "../navitems";

const mapDispatchToProps = dispatch => {
  return {
    toggleMenu: sidemenuOn => {
      dispatch(toggleMenu(sidemenuOn));
    }
  };
};

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navBarClass: "navbar navbar-expand-lg border-none bg-light-gray"
    };

    this.onClick = this.onClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll = () => {
    if (window.scrollY > 100) {
      this.setState({
        navBarClass:
          "navbar navbar-expand-lg border-none bg-light-gray nav-scroll"
      });
    } else {
      this.setState({
        navBarClass: "navbar navbar-expand-lg border-none bg-light-gray"
      });
    }
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  onClick = (e, props) => {
    e.preventDefault();
    console.log("onclick..", e.target.className);
    if (e.target.className.includes("sidemenu_btn")) {
      console.log(props.toggleMenu(true));
    }
  };
  render() {
    return (
      <nav className={this.state.navBarClass}>
        <div className="container sm-padding-10px-tb sm-padding-15px-lr">
          <a
            className="logo"
            href="#"
            onClick={this.onClick}
            data-scroll-nav="0"
          >
            {/* <img
            src={require("../../../static/img/irfan.png")}
            alt="Ashton - One Page Portfolio"
            title="Ashton - One Page Portfolio"
          /> */}
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarContent"
            aria-controls="navbarContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="icon-bar">
              <i className="fa fa-bars" />
            </span>
          </button>

          <div className="collapse navbar-collapse" id="navbarContent">
            {/* <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  href
                  onClick={this.onClick}
                  data-scroll-nav="0"
                >
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href
                  onClick={this.onClick}
                  data-scroll-nav="1"
                >
                  About
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href
                  onClick={this.onClick}
                  data-scroll-nav="2"
                >
                  Experience
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href
                  onClick={this.onClick}
                  data-scroll-nav="3"
                >
                  Portfolio
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href
                  onClick={this.onClick}
                  data-scroll-nav="4"
                >
                  Services
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href
                  onClick={this.onClick}
                  data-scroll-nav="5"
                >
                  Blog
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href
                  onClick={this.onClick}
                  data-scroll-nav="6"
                >
                  Contact
                </a>
              </li>
            </ul> */}
            <NavItems />
          </div>
        </div>

        <a
          href="#"
          style={{ cursor: "pointer" }}
          onClick={e => this.onClick(e, this.props)}
          className="sidemenu_btn sm-display-none"
          id="sidebar_toggle"
        >
          <span /> <span /> <span />
        </a>
      </nav>
    );
  }
}

export default connect(null, mapDispatchToProps)(Navbar);
